import { FC, useContext } from 'react';

import { selectorCanCommunicateWithApplicant } from 'src/components/HiringManager/utils/selectorCanCommunicateWithApplicant';
import { useTopicState } from 'src/components/ResumeCard/Actions/Chatik/hooks/useTopicState';
import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';
import { VIEW_WITHOUT_CONTACTS } from 'src/utils/constants/resumePermission';

import ChatikButton from 'src/components/ResumeCard/Actions/Chatik/Button';

const ChatikButtonWrapper: FC<{ isMobile?: boolean }> = ({ isMobile }) => {
    const { isPfpVacancy, resume } = useContext(ResumeCardActionsContext);
    const isBackoffice = useSelector((state) => state.userType) === UserType.BackOffice;
    const topicState = useTopicState();
    const isHiddenByPfp = isPfpVacancy ? resume._attributes.permission === VIEW_WITHOUT_CONTACTS : false;
    const canUseChat = useSelector(selectorCanCommunicateWithApplicant);

    if (!topicState || !canUseChat || isHiddenByPfp || (isBackoffice && !topicState.conversationMessagesCount)) {
        return null;
    }

    return <ChatikButton {...topicState} isMobile={isMobile} />;
};

export default ChatikButtonWrapper;
